import React, { useState } from 'react';
import { SiteTheme } from '../../generated/types';
import { Grid } from '@mui/material';
import { ThemeCard } from './ThemeCard';

interface SelectThemePageProps {
    isAddingMenu: boolean;
    handleCreateMenu: (theme: SiteTheme) => void;
    themes: SiteTheme[];
}
export const SelectThemeBox: React.FC<SelectThemePageProps> = ({ isAddingMenu, handleCreateMenu, themes }) => {
    const [selectedTheme, setSelectedTheme] = useState<SiteTheme | null>(null);

    const onSelectTheme = (theme: SiteTheme) => {
        setSelectedTheme(theme);
    };

    const onClickUseTheme = (theme: SiteTheme) => {
        handleCreateMenu(theme);
    };

    return (
        <div className={`flex-auto overflow-y-auto`}>
            {themes && (
                <Grid container columnSpacing={1.25}>
                    {themes.map((theme) => (
                        <Grid key={theme.id} item xs={6} sm={4} md={3} lg={12 / 5}>
                            <ThemeCard
                                theme={theme}
                                isSelected={selectedTheme?.id === theme.id}
                                isAddingMenu={isAddingMenu}
                                onSelect={() => onSelectTheme(theme)}
                                onUseTheme={() => onClickUseTheme(theme)}
                            />
                        </Grid>
                    ))}
                </Grid>
            )}
        </div>
    );
};

export default SelectThemeBox;
